export const getPrimaryServiceCost = (service, priceTierOptions = []) => {
  const prices = Array.isArray(service?.serviceprice) ? service.serviceprice : [];
  const nestedGeneralPrice = prices.find(
    (entry) => String(entry?.pricetier?.name || "").toLowerCase() === "general",
  );
  const generalTier = (Array.isArray(priceTierOptions) ? priceTierOptions : []).find(
    (entry) => String(entry?.label || "").toLowerCase() === "general",
  );
  const flatGeneralPrice = generalTier && prices.find(
    (entry) => String(entry?.price_tier_id ?? entry?.pricetier?.id ?? "") === String(generalTier.value),
  );
  const generalPrice = nestedGeneralPrice || flatGeneralPrice;
  const selectedPrice = generalPrice || (prices.length === 1 ? prices[0] : null);
  if (selectedPrice?.price === undefined || selectedPrice?.price === null || selectedPrice.price === "") {
    return "";
  }
  return String(selectedPrice.price);
};

export default getPrimaryServiceCost;
